; (function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.creditnote.show')
    .controller('MakeCreditNotePaymentController', MakeCreditNotePaymentController)

  MakeCreditNotePaymentController.$inject = [
    // Angular
    '$scope', '$uibModalInstance',

    // Managers
    'InvoiceManager',

    // Services
    'UtilService', 'DatePickerService', 'PaginationModel', 'PreferencesService',

    // Resolve
    'invoices', 'payment',
    'balance', 'creditNoteId', 'clientId', 'isUpdate'
  ]

  function MakeCreditNotePaymentController (
    // Angular
    $scope, $uibModalInstance,

    // Managers
    InvoiceManager,

    // Services
    UtilService, DatePickerService, PaginationModel, PreferencesService,

    // Resolve
    invoices, payment,
    balance, creditNoteId, clientId, isUpdate

  ) {
    var self = this
    var destroyed = false

    // Retire le watcher $rootScope de la pagination à la fermeture de la modale
    $scope.$on('$destroy', function () {
      destroyed = true
      if (self.invoicePagination) self.invoicePagination.destroy()
    })

    self.$onInit = () => {
      _.extend(self, {
        options: [
          { key: 'cash', value: 'Liquide' },
          { key: 'wire_transfert', value: 'Virement' },
          { key: 'check', value: 'Chèque' },
          { key: 'gift-card', value: 'Bon cadeau' }
        ],
        initAmount: initAmount,
        isFieldDisplayed: isFieldDisplayed,
        getInvoiceNumberFor: getInvoiceNumberFor,
        isInvoiceNotificationDisplayed: isInvoiceNotificationDisplayed,
        selectInvoice: selectInvoice,
        isAmountValid: isAmountValid,
        cancel: cancel,
        selectDate: selectDate,
        resetDate: resetDate,
        validate: validate,
        getInvoices: getInvoices,
        orderBy: orderBy,
        isUpdate: isUpdate,
        inited: false,
        maxPayment: -balance
      })

      init()
    }

    function init () {
      self.payment = payment || {}
      PaginationModel.get('invoiceCreditNotePagination', { perPage: 5 }).then(function (data) {
        // Modale déjà fermée avant la résolution : on retire tout de suite le watcher
        if (destroyed) return data.destroy()
        self.invoicePagination = data
        self.invoicePagination.orderBy = 'number'
        self.invoicePagination.reverse = false
        getInvoices()
      })
      if (hasInvoices()) {
        self.options.push({ key: 'invoice', value: 'Report sur facture' })
      }
      if (isUpdate) {
        self.selectedType = payment.type
        self.payment.date = new Date(payment.date)
      }
      self.inited = true
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.selectedType = generalPrefs.settings.defaultPaymentType
          initAmount()
        }
      })
    }

    function hasInvoices () {
      return !!invoices.data
    }

    function getInvoices () {
      InvoiceManager.get(InvoiceManager.query()
        .select(clientId, 'client')
        .select(['validated', 'sent', 'partly_paid'], 'status')
        .fields('_id number numberFormat date dueDate status balanceDue fullTotal lines payments')
        .sort(self.invoicePagination.reverse ? '' : '-' + self.invoicePagination.orderBy)
        .paginate(self.invoicePagination.toQueryOptions())).then(data => {
        self.invoicePagination.totalElements = data.meta.total
        self.invoices = data.data
      })
    }
    function orderBy (field) {
      if (self.invoicePagination.orderBy === field) {
        self.invoicePagination.reverse = !self.invoicePagination.reverse
      } else {
        self.invoicePagination.orderBy = field
        self.reverse = false
      }
      self.invoicePagination.currentPage = 0
      getInvoices()
    }

    function selectDate () {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date)
        self.paymentForm.$dirty = true
      })
    }

    function resetDate () {
      self.payment.date = null
      self.paymentForm.$dirty = true
    }

    function isInvoiceNotificationDisplayed () {
      return hasInvoices() && !(self.selectedType === 'invoice')
    }

    function getInvoiceNumberFor (obj) {
      if (obj.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(obj, 'invoice')
    }

    function isFieldDisplayed () {
      return self.hasOwnProperty('selectedType') &&
        (self.selectedType === 'cash' ||
          self.selectedType === 'wire_transfert' ||
          self.selectedType === 'check' ||
          self.selectedType === 'gift-card' ||
          self.payment.hasOwnProperty('ref'))
    }

    function getAmount () {
      return self.selectedInvoice.balanceDue < balance ? -balance : -self.selectedInvoice.balanceDue
    }

    function initAmount () {
      if (self.selectedType === 'invoice' && self.hasOwnProperty('selectedInvoice')) {
        self.payment = {
          date: new Date(),
          amount: {
            amount: getAmount(),
            currency: 'EUR'
          },
          type: 'invoice',
          ref: {
            type: 'Invoice',
            value: self.selectedInvoice._id
          }
        }
      } else if (self.selectedType === 'gift-card' || self.selectedType === 'wire_transfert' || self.selectedType === 'cash' || self.selectedType === 'check') {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref
        }
        if (self.hasOwnProperty('selectedInvoice')) {
          delete self.selectedInvoice
        }
        self.payment = {
          date: new Date(),
          amount: {
            amount: -balance,
            currency: 'EUR'
          },
          type: self.selectedType
        }
      } else {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref
        }
        if (self.hasOwnProperty('selectedInvoice')) {
          delete self.selectedInvoice
        }
      }
    }

    function selectInvoice (index) {
      self.selectedInvoice = self.invoices[index]
      self.initAmount()
    }

    function isAmountValid () {
      if (self.hasOwnProperty('selectedInvoice')) {
        return -self.selectedInvoice.balanceDue >= self.payment.amount.amount
      }
      return true
    }

    function validate () {
      $uibModalInstance.close(self.payment)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
